var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "im-popover" },
    [
      _vm.isReallyUser
        ? [
            _c(
              "transition",
              {
                attrs: { name: _vm.transition },
                on: {
                  "after-enter": _vm.handleAfterEnter,
                  "after-leave": _vm.handleAfterLeave,
                },
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.disabled && _vm.showPopper,
                        expression: "!disabled && showPopper",
                      },
                    ],
                    ref: "popper",
                    class: ["popper", _vm.popperClass],
                    on: {
                      mouseleave: _vm.onHidePopper,
                      mouseenter: _vm.onShowPopper,
                    },
                  },
                  [_vm._t("default")],
                  2
                ),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "wrapper",
          staticClass: "reference_wrap",
          attrs: { showPopper: _vm.showPopper },
          on: { mouseleave: _vm.onHidePopper, mouseenter: _vm.onShowPopper },
        },
        [_vm._t("reference")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }